import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useLanguage from "../../utils/useLanguage";
import CustomButton from "../../components/CustomButton";

//assets
import arrowIcon from "../../assets/previous_icon.png";
import CustomInputWithUnit from "../../components/CustomInputWithUnit";
import CustomCheckbox from "../../components/CustomCheckbox";

const FabricRulers = ({
  data,
  setSelectedRulers,
  measuringUnit,
  currency,
  selectedColors,
  onColorSelect,
  onInputChange,
}) => {
  const { currentDirection } = useLanguage();
  const { t } = useTranslation("general");

  const [collapsed, setCollapsed] = useState({});

  /* HANDLER FUNCTIONS */
  const handleInputValueChange = (fabricCode, colorCode, field, value) => {
    if (onInputChange) {
      onInputChange(fabricCode, colorCode, field, value);
    }
  };

  const handleDeleteRuler = (fabricCode) => {
    setSelectedRulers((prev) =>
      prev.filter((ruler) => ruler.code !== fabricCode)
    );

    onColorSelect(fabricCode, null, false);
  };

  const handleCheckboxChange = (fabricCode, colorCode) => {
    // Call the parent's handler with the new state
    onColorSelect(
      fabricCode,
      colorCode,
      !selectedColors[fabricCode]?.[colorCode]
    );
  };

  const toggleCollapse = (fabricCode) => {
    setCollapsed((prev) => ({
      ...prev,
      [fabricCode]: !prev[fabricCode],
    }));
  };

  /* USEEFECT */
  useEffect(() => {
    const initialCollapsed = {};
    data.forEach((fabric) => {
      initialCollapsed[fabric.code] = true;
    });
    // setCollapsed(initialCollapsed);
  }, [data]);

  return (
    <div
      className="c-fabric-table o-column o-column--gap-size_400 u-margin u-margin--bottom_700"
      dir={currentDirection}
    >
      {data.map((fabric) => (
        <div key={fabric.code} className="c-fabric-block">
          <div className="c-fabric-header o-row o-row--horizontal-align_space-between">
            <div onClick={() => toggleCollapse(fabric.code)}>
              <span className="c-collapse-icon" style={{ cursor: "pointer" }}>
                <img
                  src={arrowIcon}
                  alt="Collapse"
                  style={{
                    width: 16,
                    transform: collapsed[fabric.code]
                      ? "rotate(0deg)"
                      : "rotate(-90deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </span>
              <span className="c-fabric-code">
                {t("code")}: {fabric.code}
              </span>
            </div>

            <div className="o-row o-row--gap-size_300">
              <CustomButton
                variant="red"
                title={t("delete")}
                onClick={() => handleDeleteRuler(fabric.code)}
              />
            </div>
          </div>

          {!collapsed[fabric.code] && (
            <table className="c-fabric-inner-table">
              <thead>
                <tr>
                  <th>{t("choose")}</th>
                  <th>{t("colorCode")}</th>
                  <th>{t("colorName")}</th>
                  <th>{t("quantity")}</th>
                  <th>{t("price")}</th>
                </tr>
              </thead>
              <tbody>
                {fabric.colors.map((color) => (
                  <tr key={color.colorCode}>
                    <td>
                      <CustomCheckbox
                        checked={true} // Always checked in the selected rulers section
                        onChange={() =>
                          handleCheckboxChange(fabric.code, color.colorCode)
                        }
                      />
                    </td>
                    <td>{color.colorCode}</td>
                    <td>{color.colorName}</td>
                    <td>
                      <CustomInputWithUnit
                        value={color?.quantity || ""}
                        onChange={(e) =>
                          handleInputValueChange(
                            fabric.code,
                            color.colorCode,
                            "quantity",
                            e.target.value
                          )
                        }
                        unit={t(measuringUnit.title)}
                      />
                    </td>
                    <td>
                      <CustomInputWithUnit
                        value={color?.price || ""}
                        onChange={(e) =>
                          handleInputValueChange(
                            fabric.code,
                            color.colorCode,
                            "price",
                            e.target.value
                          )
                        }
                        unit={t(currency.value)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ))}
    </div>
  );
};

export default FabricRulers;
